import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnergeaFaviconLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 44,
	viewBox: "0 0 41 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M25.1512 34.3319H40.9997C40.9997 31.9747 40.5867 29.5575 39.6004 27.4947C38.0873 24.3303 35.2248 22 30.434 22C25.3728 22 22.3866 24.4452 20.8914 27.3949C20.0488 29.0574 19.6797 30.8802 19.6797 32.5158C19.6797 36.5857 22.1589 43.32 30.434 43.32C35.4662 43.32 38.3829 41.0904 39.6004 39.9985L36.2074 36.8327C34.5547 38.394 33.6451 38.9322 30.434 38.9322C27.2229 38.9322 25.1512 35.8427 25.1512 34.3319ZM35.7169 30.2855H25.1512C25.1512 28.56 27.0597 26.1 30.3397 26.1C33.6197 26.1 35.7169 28.731 35.7169 30.2855Z",
			className: "logo-text",
			fill: "#01362E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5443 17.3175L8.05116 3.08917L14.6037 12.6371L17.2247 10.3905L22.6539 20.3129C24.7132 4.21246 12.5443 -0.280613 3.93246 0.842586C1.49861 17.1302 12.7314 22.185 18.9097 21.8106L15.9142 14.6965L12.5443 17.3175Z",
			className: "logo-leaf",
			fill: "#95E362"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.368 29.293C9.74541 29.5288 8.19553 29.7541 7.11414 29.8622L12.7306 26.9416H2.52229C0.915302 28.7411 0.14849 31.0402 0 33.0448C1.87214 34.917 11.7945 38.2869 17.2237 28.5517C15.7382 28.6578 13.4909 28.9845 11.368 29.293Z",
			className: "logo-leaf",
			fill: "#95E362"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7306 26.9416L16.4748 24.9946C9.35779 22.6222 4.96745 24.2036 2.52229 26.9416H12.7306Z",
			className: "logo-leaf",
			fill: "#95E362"
		})
	]
});
export default SvgEnergeaFaviconLogo;
